import Splide from "@splidejs/splide";

export const seatSlider = () => {
  const seatSlider = new Splide(".js-seat-slider", {
    gap: "2rem",
    arrows: false,
    padding: {
      left: "2rem",
      right: "2rem",
    },
  }).mount();
};
